import { SET_NOTIFICATION } from "./action";

const initialState = {
  notification: false,
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_NOTIFICATION:
      return {
        ...state,
        notification: action.payload,
      };
    default:
      return state;
  }
};

export default reducer;
